/**
 * External Imports
 */
import { FC } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Internal Imports
 */
import { openModal, setModalType } from '../../../redux/actions';

/**
 * Style Imports
 */
import { StyledUnlistedRoundBtn } from './UnlistedRoundBtn.styles';

const UnlistedRoundBtn: FC<{}> = () => {
  const dispatch = useDispatch();

  const roundUnlistedPatient = () => {
    dispatch(setModalType('UnlistedPatientRound'));
    dispatch(openModal());
  };

  return (
    <StyledUnlistedRoundBtn
      id="Unlisted-Round-Button"
      color="blue"
      kind="primary"
      size="small"
      style={{ fontSize: '1rem', marginRight: '10px' }}
      onClick={roundUnlistedPatient}
    >
      Round on Unlisted Patient
    </StyledUnlistedRoundBtn>
  );
};

export default UnlistedRoundBtn;
